import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

type BugsnagLike = {
  notify: (error: any, cb?: (event: any) => void) => void;
  leaveBreadcrumb: (name: string, metadata?: any, type?: any) => void;
  setUser: (id: string, email?: string, name?: string) => void;
  getPlugin: (name: string) => any;
};

const apiKey = `${process.env.REACT_APP_BUGSNAG_API_KEY}`;

const noopClient: BugsnagLike = {
  notify: () => undefined,
  leaveBreadcrumb: () => undefined,
  setUser: () => undefined,
  getPlugin: () => null,
};

export const bugsnagClient: BugsnagLike = apiKey
  ? (Bugsnag.start({
      apiKey,
      releaseStage: process.env.NODE_ENV,
      appVersion: process.env.REACT_APP_VERSION,
      enabledReleaseStages: ["production", "staging", "development"],
      autoTrackSessions: true,
      collectUserIp: false,
      plugins: [new BugsnagPluginReact()],
      onError: (event) => {
        event.addMetadata("env", {
          graphqlUri: process.env.REACT_APP_GRAPHQL_URI,
          backendApi: `${process.env.REACT_APP_BACKEND_API_PROTOCOL}://${process.env.REACT_APP_BACKEND_API_DOMAIN}`,
        });
      },
    }) as any)
  : noopClient;

export const BugsnagErrorBoundary: React.ComponentType<{
  children: React.ReactNode;
}> = apiKey
  ? (bugsnagClient
      .getPlugin("react")
      .createErrorBoundary(React) as React.ComponentType<{
      children: React.ReactNode;
    }>)
  : ({ children }) => React.createElement(React.Fragment, null, children);
